import * as React from 'react';
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import LoadingButton from '@mui/lab/LoadingButton';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Iconify from '../iconify';
import Stack from '@mui/material/Stack';
import SteLib, {POPUP_INITDATA} from 'src/lib/stelib';
import 'dayjs/locale/it';
import { useFormik } from 'formik';

export default function BookPopupAdmin({state, successCallback}) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [selectedSeats, setSelectedSeats] = React.useState([]);

  const [bookingSubmitted, setBookingSubmitted] = React.useState(false);

  useEffect(() => {
    if(state?.data?.open && state?.data?.loading)
    {
      //INIT POPUP
      setSelectedSeats(state?.data?.seats);
      setActiveStep(0);
      formik.resetForm({
        values: {
         name: undefined,
         surname: undefined
        }});
      setBookingSubmitted(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.data?.open]);

  const handleClose = () => {
    state.setData(POPUP_INITDATA);
  };

  const handleSubmitBooking = () => {
    let parsedFormData = {};
    parsedFormData.timetableId = state?.data?.timetableId;
    parsedFormData.bookedBy = "SISTEMA";
    parsedFormData.phone = "N.D.";
    parsedFormData.name = formik.values.name;
    parsedFormData.surname = formik.values.surname;
    parsedFormData.type = 1;
    parsedFormData.seats = selectedSeats;
    if(parsedFormData.timetableId > 0 &&
      parsedFormData.bookedBy !== undefined && parsedFormData.bookedBy !== "" &&
      parsedFormData.seats?.length > 0)

    setBookingSubmitted(true);
    SteLib.PostRequest("/timetables/"+state?.data?.timetableId+"/book", parsedFormData, true, true)
    .then((data) => {
      setActiveStep(1);
    }).catch((message) => {
      setActiveStep(-1);
    });
  }

  const handleEndBooking = () => {
    handleClose();
    successCallback();
  }

  const validate = (values) => {
    const errors = {}

  
    return errors
  }

  const formik = useFormik({
    initialValues: {
      name: '',
      surname: ''
    },
    validate,
    onSubmit: (values) => {
      //alert(JSON.stringify(values, null, 2))
    },
  })

  return (
    <>
      <Dialog disablePortal fullWidth maxWidth="xs" open={state?.data?.open} onClose={handleClose}>   
        <DialogTitle>
          Riserva Posti <div style={{marginTop: "-.75rem", marginBottom: "-.5rem"}}></div>
          </DialogTitle>
        <DialogContent>
          {activeStep === 0 ? 
            <>
              <div style={{marginTop: "2rem", textAlign: "center"}}>
                <small>Inserisci i dati della persona per cui riservare il posto</small>
              </div>
              <Stack alignItems="center" spacing={3} style={{marginTop: "1rem"}}>
              <TextField
                    margin="dense"
                    id="name"
                    label="Nome"
                    type="text"
                    style={{width: "80%"}}
                    error={formik.errors.name}
                    helperText={formik.errors.name ? "Inserire Nome" : ""}
                    onChange={formik.handleChange} 
                    onBlur={formik.handleBlur} 
                    value={formik.values.name}
                    variant="standard"
                />
                <TextField
                    margin="dense"
                    id="surname"
                    label="Cognome"
                    type="text"
                    style={{width: "80%"}}
                    error={formik.errors.surname}
                    helperText={formik.errors.surname ? "Inserire Cognome" : ""}
                    onChange={formik.handleChange} 
                    onBlur={formik.handleBlur} 
                    value={formik.values.surname}
                    variant="standard"
                />
                </Stack><br/>
                <div style={{textAlign: "right"}}>
                  <Button onClick={handleClose}>Annulla</Button>
                  <LoadingButton loading={bookingSubmitted} onClick={handleSubmitBooking}>Prenota</LoadingButton>
                </div>
            </>
            :
            activeStep === -1 ?
            <>
              <Stack spacing={3} alignItems="center">
              <h3>Errore Generico!</h3>
              <Iconify icon={'noto:cross-mark'} style={{marginTop: ".5rem", width: "7rem",height: "7rem"}}></Iconify>
              <Button onClick={handleEndBooking}>Chiudi</Button>
              </Stack>
            </>
            :
            <>
              <Stack spacing={3} alignItems="center">
              <h3>Posti Riservati!</h3>
              <Iconify icon={'noto:party-popper'} style={{marginTop: ".5rem", width: "7rem",height: "7rem"}}></Iconify>
              <Button onClick={handleEndBooking}>Chiudi</Button>
              </Stack>
            </>      
          }
          </DialogContent>
      </Dialog>
    </>
  );
}